import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Check } from "lucide-react";

const segments = ["Particuliers", "Entreprises", "Collectivités"];

export default function CallbackForm({ compact = false, defaultService = "" }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "", segment: "Particuliers", service: defaultService, city: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast.error("Nom et téléphone requis"); return; }
    setLoading(true);
    try {
      await api.post("/leads", { ...form, source: "formulaire" });
      setSent(true);
      toast.success("Demande envoyée ! Nous vous rappelons rapidement.");
      setForm({ name: "", phone: "", email: "", segment: "Particuliers", service: "", city: "", message: "" });
    } catch {
      toast.error("Une erreur est survenue. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-xl border border-border bg-white px-4 py-3 text-sm text-forest focus:outline-none focus:ring-2 focus:ring-brand/30 placeholder:text-stone/50";

  if (sent) {
    return (
      <div className="text-center py-10" data-testid="callback-success">
        <div className="mx-auto h-16 w-16 rounded-full bg-brand/10 flex items-center justify-center mb-4">
          <Check className="text-brand" size={32} />
        </div>
        <h3 className="font-display text-2xl text-forest mb-2">Merci !</h3>
        <p className="text-stone">Votre demande a bien été reçue. Un conseiller vous recontacte sous 24h.</p>
        <button onClick={() => setSent(false)} className="mt-5 text-sm font-semibold text-brand underline" data-testid="callback-new">
          Nouvelle demande
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="callback-form">
      <div className="grid sm:grid-cols-2 gap-4">
        <input required placeholder="Nom & prénom *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={field} data-testid="cb-name" />
        <input required placeholder="Téléphone *" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className={field} data-testid="cb-phone" />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <input type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={field} data-testid="cb-email" />
        <input placeholder="Ville" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className={field} data-testid="cb-city" />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <select value={form.segment} onChange={(e) => setForm({ ...form, segment: e.target.value })} className={field} data-testid="cb-segment">
          {segments.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <input placeholder="Type de projet / prestation" value={form.service} onChange={(e) => setForm({ ...form, service: e.target.value })} className={field} data-testid="cb-service" />
      </div>
      {!compact && (
        <textarea rows={4} placeholder="Décrivez votre projet…" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={field} data-testid="cb-message" />
      )}
      <button type="submit" disabled={loading} data-testid="cb-submit"
        className="w-full rounded-full bg-brand text-cream font-semibold py-3.5 hover:bg-forest transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
        {loading ? <Loader2 className="animate-spin" size={18} /> : null}
        Être rappelé gratuitement
      </button>
      <p className="text-xs text-stone/60 text-center">Réponse sous 24h · Devis gratuit et sans engagement</p>
    </form>
  );
}
